<div class="xp-page-header__lead">
	<h1 class="xp-page-header__title">{{ heading() }}</h1>
	<ng-content select="[xpPageHeaderNote]"></ng-content>
</div>
<div class="xp-page-header__actions"><ng-content></ng-content></div>
